import '@angular/localize/init';
export * from './lib/feature-tax-income-details.module';

export * from './lib/tax-income-details/feature-tax-income-details.component';
